<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Transactions"
            bc1="App"
            bc2="Card"
            bc3="Details"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
              type="button"
              class="btn btn-gradient-danger btn-sm"
              @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section  class="invoice-preview-wrapper" v-if="transactionDetails && !isEmpty(transactionDetails)">
          <div class="row invoice-preview">
            <!-- Invoice -->
            <div class="col-12" v-if="transactionDetails.card">
              <div class="card invoice-preview-card">
                <div class="card-body invoice-padding pb-0">
                  <!-- Header starts -->
                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                    <div>
                      <div class="logo-wrapper">
                        <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                      </div>
                      <h1 class="mb-4" >
                        Third Party Details
                      </h1>
                      <table class="table-responsive">
                        <tr v-for="(ItemValue,itemKey) in transactionDetails.card.details">
                          <td class="pr-5"><strong class="text-primary">{{itemKey}}</strong></td>
                          <td class="pr-5"><strong class="text-success">{{ItemValue}} </strong></td>
                        </tr>
                      </table>
<!--                      <p class="card-text mb-25 text-success"  v-for="(ItemValue,itemKey) in transactionDetails.card.details">-->
<!--                        <strong class="text-primary">{{itemKey}} : </strong>{{ItemValue}}-->
<!--                      </p>-->
                      <p class="card-text mb-25 text-primary" v-if="!transactionDetails.card && !transactionDetails.card.details">No Data Avalibale</p>
                    </div>
                    <div class="mt-md-0 mt-2">
                      <h5 class="invoice-title mb-0">
                        Card Holder:
                        <span class="invoice-number">{{transactionDetails.card?transactionDetails.card.card_holder_name:'N/A'}}</span>
                      </h5>
                      <h5 class="invoice-title mb-0">
                        Card Number:
                        <span class="invoice-number">{{transactionDetails.card?transactionDetails.card.card_number:'N/A'}}</span>
                      </h5>
                    </div>
                  </div>
                  <!-- Header ends -->
                </div>




              </div>
            </div>
            <!-- /Invoice -->

          </div>
        </section>


      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['propFilters'],
  mounted() {
    this.getTransactionsDetails()
  },
  data() {
    return {
      transactionDetails: [],
      previousRoute:null

    }
  },
  methods: {
    backTo(){
      if(this.previousRoute){
        if(this.previousRoute == 'transactions'){
          let propFilters = this.propFilters
          this.$router.push({name:'transactions',params:{propFilters}})
          // if(this.$route.params.transactionStatus == 'normal'){
          //   this.$router.push({name:'transactions',query: { tab: 1 },params:{propFilters}})
          // }else if(this.$route.params.transactionStatus == 'pending'){
          //   this.$router.push({name:'transactions',query: { tab: 2 },params:{propFilters}})
          // }
          // else if(this.$route.params.transactionStatus == 'failure'){
          //   this.$router.push({name:'transactions',query: { tab: 3 },params:{propFilters}})
          // }else{
          //   this.$router.push({name:'transactions',params:{propFilters}})
          // }
        }else{
          this.$router.back()
        }
      }else{
        this.$router.back()
      }

    },
    getTransactionsDetails() {
      let data = {
        transactionId: this.$route.params.id,
        transactionDetail: 1
      }
      this.makeRequest("post", "v1/get-transaction", data, {}, false).then(
        (callResponse) => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            let responseData = callResponse.response.data.data;
            if (code == 200) {
              this.transactionDetails = responseData
            }
          }
        }
      );
    }
  },
  beforeRouteEnter(to, from, next) {



    next(vm => vm.previousRoute = from.name)
  }


}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

